var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-page-my-journey-measument-chart-skeleton"},[_c('div',{staticClass:"container"},[_c('AnimatedPlaceholder',{attrs:{"width":"90px","height":"45px"}}),_c('AnimatedPlaceholder',{attrs:{"width":"60px","height":"15px"}})],1),_c('PageMyJourneyMeasumentChartBoxSkeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }